<section>
  <p-dialog *ngIf="displayError&&entityErrors" [(visible)]="displayError"
            header="Validation Error" [responsive]="true" modal="true" dismissableMask="true" appendTo="body"
            [style]="PrimeNgConfig.DialogStyle65" [contentStyle]="{'overflow-y':'scroll'}"
            (onHide)="onClickClose()" [closable]="false">

    <app-data-table [columns]="tableColumns" [value]="entityErrors" sortField="index" [bodyTemplate]="bodyTemplate">
      <ng-template #bodyTemplate let-row="row" let-rowIndex="rowIndex" let-columns="columns">
        <tr>
          <td *ngFor="let col of columns" [ngSwitch]="col.field">
            <span class="p-column-title">{{col.header}}</span>
            <span class="p-cell">
              <div *ngSwitchCase="'index'">
                {{rowIndex + 1}}
              </div>
              <div *ngSwitchDefault>{{row[col.field]}}</div>
            </span>
          </td>
        </tr>
      </ng-template>
    </app-data-table>

    <p-footer>
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Close" (click)="onClickClose()"></button>
    </p-footer>

  </p-dialog>
</section>
